module.exports = __webpack_public_path__ + "static/media/Website.30cc6ee1.jpg";